module.exports = __webpack_public_path__ + "static/media/outline-p4-white.e1f11034.png";